import React, { createContext, useCallback, useMemo, useState } from 'react'
import Component from './Component'
import { QuizInviteType } from '../../lib/types'

// @ts-ignore
export const CreateQuestionnaireContext = createContext<{
  actions: {
    open: (callback: (questionnaire: QuizInviteType | QuizInviteType[] | null) => void) => void
    close: (questionnaire?: QuizInviteType) => void
  }
}>({
  // @ts-ignore
  actions: {}
})

export const CreateQuestionnaireProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [callBack, setCallBack] = useState<((questionnaire: QuizInviteType | null) => void) | undefined>(undefined)

  const open = useCallback((callback: (questionnaire: QuizInviteType | null) => void) => {
    setIsOpen(true)
    setCallBack(() => callback)
  }, [])

  const close = useCallback(
    (questionnaire?: QuizInviteType) => {
      setIsOpen(false)
      if (callBack) callBack(questionnaire || null)
      setCallBack(undefined)
    },
    [callBack]
  )

  const value = useMemo(
    () => ({
      actions: {
        open,
        close
      }
    }),
    [open, close]
  )

  return (
    <CreateQuestionnaireContext.Provider value={value}>
      {isOpen && <Component />}
      {children}
    </CreateQuestionnaireContext.Provider>
  )
}
